import { Toast } from 'mint-ui';

let jsBridge;


function getJsBridage() {
    if (!jsBridge) {
        if (window.tv) {
            let postMessage = function (event, params = {}) {
                window.tv.postMessage(event, JSON.stringify(params))
            }
            jsBridge = {
                navigateBack() {
                    if (window.appVersion == '3.3.0') {
                        window.tv.navigateBack()
                    } else {
                        postMessage('goBack')
                    }
                },
                webShare(title, text, img, path) {
                    img = img.replace('https://', 'http://');
                    path = path.replace('https://', 'http://');
                    if (window.appVersion == '3.3.0') {
                        window.tv.webShare(title, text, img, path)
                    } else {
                        postMessage('share', {
                            title,
                            text,
                            img,
                            path
                        })
                    }
                },
                openView(url, inner, hideHeader) {
                    if (window.appVersion == '3.3.0') {
                        window.tv.openView(url, inner)
                    } else {
                        postMessage('openView', {
                            url,
                            inner,
                            hideHeader
                        })
                    }
                },
                fyPlayer(movid, urlid) {
                    postMessage('fyPlayer', {
                        movid,
                        urlid,
                    })
                }
            }
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsBridge) {
            let postMessage = function (event, params = {}) {
                window.webkit.messageHandlers.jsBridge.postMessage(JSON.stringify({
                    event,
                    params
                }))
            }
            jsBridge = {
                navigateBack() {
                    postMessage('goBack')
                },
                webShare(title, text, img, path) {
                    postMessage('share', {
                        title,
                        text,
                        img,
                        path
                    })
                },
                openView(url, inner, hideHeader) {
                    postMessage('openView', {
                        url,
                        inner,
                        hideHeader
                    })
                },
                fyPlayer(movid, urlid) {
                    postMessage('fyPlayer', {
                        movid,
                        urlid,
                    })
                }
            }
        } else if (window.flutter_inappwebview) {
            let postMessage = function (event, params = {}) {
                window.flutter_inappwebview.callHandler('postMessage', JSON.stringify({
                    event,
                    params
                }))
            }
            jsBridge = {
                navigateBack() {
                    postMessage('goBack')
                },
                webShare(title, text, img, path) {
                    postMessage('share', {
                        title,
                        text,
                        img,
                        path
                    })
                },
                openView(url, inner, hideHeader) {
                    postMessage('openView', {
                        url,
                        inner,
                        hideHeader
                    })
                },
                fyPlayer(movid, urlid) {
                    postMessage('fyPlayer', {
                        movid: parseInt(movid),
                        urlid: parseInt(urlid),
                    })
                }
            }
        } else if (window.tvFlutter) {
            let postMessage = function (event, params = {}) {
                window.tvFlutter.postMessage(JSON.stringify({
                    event,
                    params
                }))
            }
            jsBridge = {
                navigateBack() {
                    postMessage('goBack')
                },
                webShare(title, text, img, path) {
                    postMessage('share', {
                        title,
                        text,
                        img,
                        path
                    })
                },
                openView(url, inner, hideHeader) {
                    postMessage('openView', {
                        url,
                        inner,
                        hideHeader
                    })
                },
                fyPlayer(movid, urlid) {
                    postMessage('fyPlayer', {
                        movid: parseInt(movid),
                        urlid: parseInt(urlid),
                    })
                }
            }
        } else {
            jsBridge = {
                navigateBack() {
                    Toast('not found jsbridge')
                },
                webShare(title, text, img, path) {
                    Toast('not found jsbridge')
                },
                openView(url, inner, hideHeader) {
                    Toast('not found jsbridge')
                    window.location.href = url
                },
                fyPlayer(movid, urlid) {
                    Toast('not found jsbridge')
                }
            }
        }
    }
    return jsBridge
}

export default {
    error(message) {
        Toast(message)
    },
    toast(message) {
        Toast(message)
    },
    callShare(title, text, img, path) {
        if (title.length > 20) {
            title = title.substr(0, 20) + '...'
        }
        getJsBridage().webShare(title, text, img, path)
    },
    callGoBack() {
        getJsBridage().navigateBack()
    },
    openView(url, inner, hideHeader = false) {
        getJsBridage().openView(url, inner, hideHeader)
    },
    fyPlayer(movid, urlid) {
        getJsBridage().fyPlayer(movid, urlid)
    }
}


// WEBPACK FOOTER //
// ./src/app.js